import { ContentLocalesI } from '~src/interfaces/session.types';
import { SurveyScopes } from '~src/modules/surveys/interfaces';

export interface SurveyTypes {
  general: 'general';
  three_sixty: 'three_sixty';
  bottom_up: 'bottom_up';
  top_down: 'top_down';
  groups: 'groups';
}

export enum SurveySubjectTypes {
  General = 'general',
  Groups = 'groups',
  People = 'people',
}

export enum SurveyStatus {
  Active = 'active',
  Draft = 'draft',
}

export enum SurveyUseCase {
  ThreeSixty = 'three_sixty',
  BottomUp = 'bottom_up',
  TopDown = 'top_down',
}

export interface ESSurvey {
  id: string;
  name: ContentLocalesI;
  description: ContentLocalesI;
  subject: SurveySubjectTypes;
  use_case: SurveyUseCase;
  topics: Record<string, string[]>; // maps topic id to question ids
  status: SurveyStatus;
  scope: SurveyScopes;
  created_by: string;
  about: string[];
  visible: string[];
  attributes_visibility: boolean;
  show_in_heatmap_toprow: boolean;
  ask: string[];
  share_with_subject: boolean;
}